import React from "react";
import styled from "styled-components";
import { StyledButton } from "../../../CommonUI/BuildlingBlocks/StyledButton";

import { StyledHorizontalSplit } from "../../../CommonUI/BuildlingBlocks/StyledHorizontalSplit";

import { PropertyEditorBoolean } from "../../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import { StyledFormHelperText } from "./CommonStyled";

import { PropertyEditorInteger } from "../../../CommonUI/PropertyEditing/PropertyEditorInteger";
import { IssueData } from "../../Utilities/ControlRenderContext";

import { FileFormControl } from "../FileFormControl";
import { CloudUploadIcon } from "../../../CommonUI/Icon/CloudUploadIcon";
import { DownloadIcon } from "../../../CommonUI/Icon/DownloadIcon";
import { FilePreview } from "../../../CommonUI/BuilderUI/FileUploadLayer";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";
import { FileData } from "../../../rule-engine-core/Common/FileData";

class XFileDownloadEditUI extends React.Component<{ editMe: FileDownloadFormControl }> {
    render() {
        return (
            <UISpacedBoxContent>
                {this.props.editMe.renderBaseDataControlEditor()}

                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    propertyName="showFileName"
                    label="Show File Name"
                />
                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    propertyName="showFileSize"
                    label="Show File Size"
                />
                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    propertyName="showPreview"
                    label="Show Preview"
                />
                <PropertyEditorInteger
                    editObject={this.props.editMe}
                    propertyName="filesLimit"
                    label="Files Limit"
                />
            </UISpacedBoxContent>
        );
    }
}

export class FileDownloadFormControl extends FileFormControl {
    readonly __type: string = "File Download";

    download = (file: FileData) => {
        const element = document.createElement("a");
        element.setAttribute("href", URL.createObjectURL(new Blob([file.data])));
        element.setAttribute("download", file.fileName);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    };

    downloadAll = () => {
        const files = this.getFileObjects();

        for (let file of files) {
            this.download(file);
        }
    };

    render() {
        const issueData: IssueData | null = this.getFormContext()!.getControlContext(this)!.getRuntimeIssueData();
        const issueText: string = issueData?.text || "";

        const files = this.getFileObjects();

        return (
            <DownloadControlRender className="DownloadControl-root">
                {this.label && <UILabel variant={"form_label"}>{this.label}</UILabel>}
                <div className="DownloadControl-title">Download your files:</div>
                <div className="DownloadControl-upload">
                    <div className="DownloadControl-placeholderText">
                        {files.length === 0 ? "You have no files." : ""}
                    </div>
                    <UploadButton
                        onClick={this.openLayer}
                        data-testid="btn-xFileUpload-upload"
                    >
                        <CloudUploadIcon /> Upload
                    </UploadButton>
                </div>
                {files.length > 0 && (
                    <FilePriviewList>
                        {files.map((f, idx) => (
                            <FilePreview
                                file={f}
                                key={idx}
                                showPreview={this.showPreview}
                                showFileName={this.showFileName}
                                showFileSize={this.showFileSize}
                                index={idx}
                                onDelete={this.deleteFile}
                                showDownload={true}
                                onUpdate={this.updateFile}
                            />
                        ))}
                    </FilePriviewList>
                )}
                <StyledHorizontalSplit
                    marginTop={files.length === 0 ? 15 : 18}
                    marginBottom={20}
                    background={"" + UIStyleConstants.GRAY_LIGHTER_COLOR}
                />
                <div className="DownloadControl-bottomLine">
                    <StyledButton
                        variant="contained"
                        sx={{ background: UIStyleConstants.BLUE_COLOR }}
                        startIcon={<DownloadIcon />}
                        style={{ marginBottom: "30px" }}
                        onClick={this.downloadAll}
                        data-testid="btn-xFileDownload-downloadall"
                        disabled={files.length === 0}
                        ref={this.ref}
                    >
                        Download All
                    </StyledButton>
                </div>

                {this.renderLayerContent()}
                {issueText && (
                    <StyledFormHelperText error={Boolean(issueText)}>{issueText ? issueText : ""}</StyledFormHelperText>
                )}
            </DownloadControlRender>
        );
    }

    renderEditUI(): JSX.Element | null {
        return <XFileDownloadEditUI editMe={this} />;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "__type");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type");
    }

    protected updateFile = (file: FileData, index: number) => {
        if (this.valueName) {
            let oldfiles = this.getFileObjects();
            oldfiles.splice(index, 1, file);
            this.setFormDataValue(this.valueName, oldfiles);
        }
    };
}

const DownloadControlRender = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  .DownloadControl-title {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 140%;
    /* identical to box height, or 20px */
    /* main / black */

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

    margin-bottom: 20px;
  }

  .DownloadControl-upload {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .DownloadControl-placeholderText {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 140%;
      /* identical to box height, or 17px */

      display: flex;
      align-items: center;

      /* main/text */

      color ${UIStyleConstants.GRAY_COLOR};;
    }
  }

  .DownloadControl-bottomLine {
    display: flex;
    justify-content: center;
  }
`;

const UploadButton = styled.div`
    cursor: pointer;

    display: flex;
    align-items: center;

    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 140%;
    /* identical to box height, or 20px */

    text-align: right;

    /* main / black */

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
`;

const FilePriviewList = styled.div`
    background: ${UIStyleConstants.GRAY_COLOR};
    padding: 4px 12px;

    margin-top: 8px;
`;
